import { Patient } from "@/Common/Models/Patient/Patient";
import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum LabViewBelowPatientBannerRegistryComponentId {
    LaunchOacisButton = 0
}

type LabViewBelowPatientBannerRegistryProps = {
    patient: Patient;
};

class LabViewBelowPatientBannerRegistry extends BaseComponentRegistry<LabViewBelowPatientBannerRegistryComponentId, LabViewBelowPatientBannerRegistryProps> {}

const LabViewBelowPatientBannerRegistryView = createRegistryListView(() => LabViewBelowPatientBannerRegistry.getInstance());

export {
    LabViewBelowPatientBannerRegistry,
    LabViewBelowPatientBannerRegistryComponentId,
    LabViewBelowPatientBannerRegistryView
};

export type { LabViewBelowPatientBannerRegistryProps };
